import React from 'react';
import {Tabs} from './Tabs';

export const Protocols = (props) => {
  const data = props.data;

  return (
    <section className="pt-lg-16 pt-9 pt-md-11 pb-11 pb-lg-13">
      <div className="container">
        <div className="row">
          <div className="col-12 col-xl-10 offset-xl-1">
            <div className="mb-4 mb-md-6 d-flex">
              <span className="zg-label bg-purple me-2">{data.number}</span>
              <span className="zg-label bg-purple">{data.subtitle}</span>
            </div>
            <h2 className="h3 mb-8 mb-md-11" dangerouslySetInnerHTML={{__html: data.title}}></h2>

            <Tabs tabsData={data.items}/>
          </div>
        </div>
      </div>
    </section>
  )
}
